import { render, staticRenderFns } from "./discount-codes.vue?vue&type=template&id=52afad69"
import script from "./discount-codes.vue?vue&type=script&lang=js"
export * from "./discount-codes.vue?vue&type=script&lang=js"
import style0 from "./discount-codes.vue?vue&type=style&index=0&id=52afad69&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52afad69')) {
      api.createRecord('52afad69', component.options)
    } else {
      api.reload('52afad69', component.options)
    }
    module.hot.accept("./discount-codes.vue?vue&type=template&id=52afad69", function () {
      api.rerender('52afad69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editEvent/discount-codes.vue"
export default component.exports